export interface DivHrPoint {
  timestamp: Date;
  divPerHour: number; // rate
  divineOrbsGained: number; // total gained in that window
}

/**
 * Given an array of time‐series points sorted ascending by timestamp
 * (with cumulative divine orb count at each 15min interval),
 * compute the per‐hour gain at each timestamp by looking back exactly 1h.
 */
export function computeDivHrFromHistory(history: Array<{ timestamp: Date; cumulativeDivineOrbs: number }>): DivHrPoint[] {
  const result: DivHrPoint[] = [];
  let left = 0;

  for (let right = 0; right < history.length; right++) {
    const end = history[right];
    const windowStartTime = new Date(end.timestamp.getTime() - 60 * 60 * 1000);

    // advance left until history[left].timestamp ≥ windowStartTime
    while (left < right && history[left].timestamp < windowStartTime) {
      left++;
    }

    const startPoint = history[left];
    const gained = Math.max(0, end.cumulativeDivineOrbs - startPoint.cumulativeDivineOrbs);
    // We measure over 1h exactly, so rate = gained per hour
    const divPerHour = gained;

    result.push({
      timestamp: end.timestamp,
      divineOrbsGained: gained,
      divPerHour,
    });
  }

  return result;
}
